import './VenuePhotos.css';

import React from 'react';
import { IPhoto } from 'btdt-types';
import PhotoLightbox from './PhotoLightbox';
import config from '../../../../config';

interface IProps {
  photos: IPhoto[] | undefined;
}

function getPhotoUrl(url: string): string {
  if (url.startsWith('http')) return url;
  return config.apiBaseUrl.replace(/\/$/, '') + url;
}

function VenuePhotos({ photos }: IProps): React.ReactElement | null {
  const [lightboxIndex, setLightboxIndex] = React.useState<number | null>(null);

  if (!photos?.length) {
    return null;
  }

  return (
    <>
      <h2 style={{ marginTop: 32 }}>תמונות</h2>
      <div className="VenuePhotos-grid">
        {photos.map((photo, index) => (
          <img
            key={photo.id}
            className="VenuePhotos-thumb"
            src={getPhotoUrl(photo.url)}
            alt={photo.caption || ''}
            onClick={() => setLightboxIndex(index)}
          />
        ))}
      </div>
      {lightboxIndex !== null && (
        <PhotoLightbox
          photos={photos}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}
    </>
  );
}

export default VenuePhotos;
